// console.log('repid', window.repID)

console.log('window.customerInfoMetafields', window.customerInfoMetafields);
console.log('check', !!window?.customerInfoMetafields?.customerId);
class HeaderComponent extends HTMLElement {
  constructor() {
    super();
    // Promise that resolves when contentfulLoaded event is fired
    const contentfulReady = new Promise((resolve) => {
      document.addEventListener('contentfulLoaded', () => resolve());
    });

    // Promise that resolves when DOM is fully loaded
    const domReady = new Promise((resolve) => {
      if (document.readyState === 'complete') {
        resolve();
      } else {
        window.addEventListener('DOMContentLoaded', () => resolve());
      }
    });

    // Wait for both the DOM to be ready and the contentfulLoaded event
    Promise.all([domReady, contentfulReady]).then(() => {
      this.handleConfigLoaded();
    });
  }

  handleConfigLoaded() {
    var elWholesale = document.querySelector('[data-wholesale]');
    const isWholesale = elWholesale.getAttribute('data-wholesale') === 'true';

    var elCustomerID = document.querySelector('[data-customer-id]');
    const customerID = elCustomerID.getAttribute('data-customer-id');
    
    function redirectIfLoggedIn() {
      const location = window?.location;
      const pathname = location?.pathname;
      const searchParams = location?.search;
      
      if (!!customerID?.length && isWholesale) {
        let newPathname = pathname;
        if (pathname.endsWith('-r')) {
          newPathname = pathname.slice(0, -2);
        } else if (pathname.endsWith('-r/')) {
          newPathname = pathname.slice(0, -3);
        }

        if (newPathname !== pathname) {
          const newUrl = `${location.origin}${newPathname}${searchParams}`;
          window.location.replace(newUrl);
        }
      }
    }
    
    redirectIfLoggedIn();

    if (window.newULifeConfig.als == '1') {
      var shoppingWithElement = document.getElementById('nul-shopping-with');
      if (shoppingWithElement) shoppingWithElement.style.display = 'none';
    }

    this.removeSuffixIfWholesale = str => {
      const allowRetail = window.newULifeConfig.retailMarkets.some(market => market === window.newULifeConfig.currentMarketData.value);
      return ( isWholesale || !allowRetail ) && str.endsWith("-r") ? str.slice(0, -2) : str;
    };
    this.useContentful();
  }

  useContentful() {
    this.translations = window.contentfulTranslations;
    this.menuRef = this.translations.fields.reference2.fields;
    this.ourStoryRef = this.menuRef.reference1.fields;
    this.productsRef = this.menuRef.reference2.fields;
    this.discoverRef = this.menuRef.reference3.fields;
    this.shopRef = this.menuRef.reference4.fields;
    this.earnRef = this.menuRef.reference5.fields;
    this.buildDesktopTopBar();
    this.buildDesktopMenu();
    this.buildMobileMenu();

    this.liveShopifyMarkets = window.contentfulTranslationsGlobal.map(o => o.fields.whitelistedMarkets[0]);
  }

  getShopLinkUrl(fields) {
    const buttonUrl = fields?.buttonUrl?.trim();
    if (buttonUrl) return buttonUrl;

    return `${window.newULifeConfig.currentShopUrl}${this.removeSuffixIfWholesale(fields.storeProductUrl)}`;
  }

  marketChangeForCustomer(selectedMarket, redirectUrl) {
    var customerEmail = window.customerEmail;
    if (!!customerEmail) {
        var correctedMarket = selectedMarket === "USA" ? "United States" : selectedMarket;
        var windowPath = window.location.pathname;

        var dataMarket = {
            email: customerEmail,
            market: correctedMarket,
            redirect_url: redirectUrl,
        };

      
        fetch(window.stApp.Static.endpoint["multipass-link"], {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataMarket)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response failure');
            }
            return response.json();
        })
        .then(data => {
            var respURL = data.data.url.toString();
            if (data.statusCode === 200) window.location.assign(respURL);
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }
}

redirectToNonShopifyMarket(bydesignStoreHref, market) {
  
  fetch(window.stApp.Static.apiRoot + '/customers/loyalty-rep-guid', {
    method: "POST",
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({byDesignID: window?.customerInfoMetafields?.customerId })
})
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response failure");
      }
      return response.json();
    })
    .then((data) => {
      var respGuid = data.data.guid;
      var respUrl = bydesignStoreHref + '/#/seamless/repbyguid/' + respGuid + '?country=' + market.toUpperCase();
      if (data.status === 200) {
        window.location.assign(respUrl);
      } else {
        window.location.assign(bydesignStoreHref);
      };
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

  getPathWithoutLocale(pathname) {
    const localePrefixes = Array.from(
      new Set([
        ...window.newULifeConfig.activeMarketLanguages
          .map((lang) => lang.shopifyHref)
          .filter((href) => href && href !== '/'),
        ...Object.values(window.newULifeConfig.shopifyURLs),
      ])
    );
    const localeSegments = new Set(
      localePrefixes
        .map((prefix) => prefix.replace(/^\/+/, '').toLowerCase())
        .filter(Boolean)
    );
    const pathSegments = pathname.split('/');
    const firstSegment = (pathSegments[1] || '').toLowerCase();

    return localeSegments.has(firstSegment)
      ? `/${pathSegments.slice(2).join('/')}`.replace(/\/+$/, '') || '/'
      : pathname;
  }

  buildLanguageTargetPath(languageHref) {
    let normalizedLanguageHref = (languageHref || '/').replace(/\?.*$/, '');
    if (!normalizedLanguageHref.startsWith('/')) {
      normalizedLanguageHref = `/${normalizedLanguageHref}`;
    }
    if (normalizedLanguageHref.length > 1 && normalizedLanguageHref.endsWith('/')) {
      normalizedLanguageHref = normalizedLanguageHref.slice(0, -1);
    }

    const pathWithoutLocale = this.getPathWithoutLocale(window.location.pathname || '/');
    const currentSuffix = `${pathWithoutLocale}${window.location.search || ''}${window.location.hash || ''}`;
    return normalizedLanguageHref === '/'
      ? currentSuffix
      : `${normalizedLanguageHref}${currentSuffix === '/' ? '' : currentSuffix}`;
  }

  buildLanguageTargetUrl(languageHref, shopifyRootUrl = '') {
    let normalizedLanguageHref = (languageHref || '/').replace(/\?.*$/, '');
    if (!normalizedLanguageHref.startsWith('/')) {
      normalizedLanguageHref = `/${normalizedLanguageHref}`;
    }
    if (normalizedLanguageHref.length > 1 && normalizedLanguageHref.endsWith('/')) {
      normalizedLanguageHref = normalizedLanguageHref.slice(0, -1);
    }

    if (!shopifyRootUrl) {
      return normalizedLanguageHref;
    }

    try {
      return new URL(normalizedLanguageHref, shopifyRootUrl).toString();
    } catch (error) {
      return `${shopifyRootUrl.replace(/\/$/, '')}${normalizedLanguageHref}`;
    }
  }


  // DESKTOP MENU

  buildDesktopTopBar() {

    const htmlContent = window.newULifeConfig.availableLanguages.map((isoCode) => {
      
      const language = window.newULifeConfig.activeMarketLanguages.find((lang) => lang.shopifyValue === isoCode);

      if (language) {
        const targetPath = this.buildLanguageTargetPath(language.shopifyHref);
        
        return `
        <a 
          href="${targetPath}" 
          class="no-underline" 
          data-language-market="${window.newULifeConfig.currentCountry}"
          data-is-topbar="true"
        >
          <p
            class="font__largeBody font--semibold font--gray selectable"
          >
            ${language.name}
          </p>
        </a>
        `;
      }
      return ''; // return empty string if no match
    }).join('');

    const topBarElement = document.getElementById('languages-list');
    topBarElement.innerHTML += htmlContent;

    this.addDesktopEventListeners();
  }

  buildDesktopMenu() {    
    const menu = [
      { text: this.menuRef.text1, fnName: 'buildOurStoryMenu' }, // our story
      // { text: this.menuRef.text2, fnName: 'buildProductMenu' }, // products
      { text: this.menuRef.text3, fnName: 'buildDiscoverMenu' }, // discover
      { text: this.menuRef.text4, fnName: 'buildShopMenu' }, // shop
      { text: this.menuRef.text5, fnName: 'buildEarnMenu' }, // earn
    ];
  
    const navElement = document.getElementById('header-nav');
  
    const listElement = document.createElement('ol');
    navElement.appendChild(listElement);
  
    menu.forEach((o, index) => {
      const listItem = document.createElement('li');
      const linkElement = document.createElement('span');
      
      linkElement.classList.add('text--transform-uppercase', 'inverted', 'selectable')
      linkElement.textContent = o.text;
      listItem.appendChild(linkElement);
      listItem.appendChild(this[o.fnName]());
  
      listElement.appendChild(listItem);
    });
  
    // // Check whitelist to see if market is whitelisted for earn with us page.
    // const { whitelist } = earnWithUsHref;
    // const menuItems = !whitelist.includes(market)
    //   ? menuTexts.slice(0, 4)
    //   : menuTexts;
  }

  buildOurStoryMenu() {
    const htmlContent = `
      <div class="mega-dropdown mega-dropdown_our-story font__body-condensed text--transform-uppercase py--8" data-style="width: 18rem;">
        <div class="page-width column columns__4 rows__auto gap--column-3 gap--row-1">
          <h3 class="font--primary-dark font--bold">${this.ourStoryRef.reference1.fields.title}</h3>
          <p class="mb--2 text--transform-none font--gray-light">
            ${this.ourStoryRef.reference1.fields.description}
          </p>
          <div>
            <ol class="row gap--2 column--start">
              <li><a href="${window.newULifeConfig.marketDomain}/leadership/">${this.ourStoryRef.reference1.fields.reference1.fields.listArray[0].fields.textString}</a></li>
              <li><a href="${window.newULifeConfig.marketDomain}/company/">${this.ourStoryRef.reference1.fields.reference1.fields.listArray[1].fields.textString}</a></li>
              <li><a href="${window.newULifeConfig.marketDomain}/mission-vision-values/">${this.ourStoryRef.reference1.fields.reference1.fields.listArray[2].fields.textString}</a></li>
            </ol>
          </div>
          <h3 class="font--primary-dark font--bold">${this.ourStoryRef.reference2.fields.title}</h3>
          <p class="mb--2 text--transform-none font--gray-light">
            ${this.ourStoryRef.reference2.fields.description}
          </p>
          <div>
            <ol class="row gap--2 column--start">
              <li><a href="${window.newULifeConfig.marketDomain}/what-are-hormones/">${this.ourStoryRef.reference2.fields.reference1.fields.listArray[0].fields.textString}</a></li>
              <li><a href="${window.newULifeConfig.marketDomain}/improving-metabolism/">${this.ourStoryRef.reference2.fields.reference1.fields.listArray[1].fields.textString}</a></li>
              <li><a href="${window.newULifeConfig.marketDomain}/innovative-anti-aging/">${this.ourStoryRef.reference2.fields.reference1.fields.listArray[2].fields.textString}</a></li>
            </ol>
          </div>
          <div class="row--span-3 border--left border--palette_neutral-500 pl--3">
            <p class="mb--3 text--transform-none font--gray">
              ${this.ourStoryRef.reference4.fields.item1}
            </p>
            <div class="iframe-outer">
              <div class="embed-container">
                <iframe src="${this.ourStoryRef.reference4.fields.videoUrl}" width="auto" allow="fullscreen"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  
    const content = document.createElement('div');
    content.innerHTML += htmlContent;
    return content;
  }

  buildProductMenu() {
    const htmlContent = `
      <div class="mega-dropdown mega-dropdown_products py--8 text--transform-uppercase" data-style="width: 18rem;">
        <div class="page-width column column--center">
          <div class="column columns__max-content gap--8">
            <ol class="row gap--1-5 row--center-items">
              ${this.productsRef.reference1.fields.listArray.map(({ fields }) => 
                `<li><a href="${window.newULifeConfig.marketDomain}${this.removeSuffixIfWholesale(fields.url)}">${fields.buttonName}</a></li>`
              ).join('')}
            </ol>
            <div class="row gap--5 column--center">
              <img
                alt="products-image"
                layout="intrinsic"
                data-testid="image-all_products_menu"
                sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw"
                srcset="https://newulife.com/_next/image/?url=%2Fimages%2Fproducts%2Fnul-products-us.webp&w=350&q=75 350w, https://newulife.com/_next/image/?url=%2Fimages%2Fproducts%2Fnul-products-us.webp&w=384&q=75 384w, https://newulife.com/_next/image/?url=%2Fimages%2Fproducts%2Fnul-products-us.webp&w=750&q=75 750w, https://newulife.com/_next/image/?url=%2Fimages%2Fproducts%2Fnul-products-us.webp&w=1200&q=75 1200w"
                src="https://newulife.com/_next/image/?url=%2Fimages%2Fproducts%2Fnul-products-us.webp&w=1200&q=75"
                width="250"
                height="250"
                decoding="async"
                data-nimg="future"
                loading="lazy"
                style="color: transparent; height: 150px; width: 291px; background-size: cover; background-position: 50% 50%; background-repeat: no-repeat; background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 250 250'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='20'/%3E%3C/filter%3E%3Cimage filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='/images/placeholder-image.png'/%3E%3C/svg%3E');">
              </img>
              <p class="font--gray-light">${this.productsRef.text1}</p>
            </div>
          </div>
        </div>
      </div>
    `;
  
    const content = document.createElement('div');
    content.innerHTML += htmlContent;
    return content;
  }

  buildDiscoverMenu() {      
    var currentMarketCountry = window.newULifeConfig.currentCountry === "USA" ? "United States" : window.newULifeConfig.currentCountry;
    var blogPodcastWhitelist = this.discoverRef.reference2.fields.whitelist.some((market) => { return market === currentMarketCountry });
    var educationWhitelist = this.discoverRef.reference5.fields.whitelist.some((market) => { return market === currentMarketCountry });

    const htmlContent = `
      <div
        class="mega-dropdown mega-dropdown__discover py--8 text--transform-uppercase font--gray"
        data-style="width: 18rem;"
      >
        <div class="page-width column columns__4 gap--6">
          <div class="row row--start gap--2">
            <h3 class="font--primary-dark">${this.discoverRef.reference1.fields.title}</h3>
            <ol class="row gap--2">
              ${this.discoverRef.reference1.fields.listArray.map(({ fields }) => `
                <li><a href="${window.newULifeConfig.marketDomain}${fields.href}"><span>${fields.textString}</span></a></li>
              `).join('')}
            </ol>
          </div>
          ${
            blogPodcastWhitelist 
             ? `
              <div>
                <h3 class="mb--2 font--primary-dark">${this.discoverRef.reference2.fields.title}</h3>
                <div class="display-grid columns__2 gap--2">
                  <div>
                    <a href="${window.newULifeConfig.marketDomain}/podcast/" class="mb--2"
                      >
                      <span class="mb--2">${this.discoverRef.reference2.fields.text1}</span>
                    <picture class="mb--2 shadow--small"
                        ><img
                          alt="pulse podcast menu thumb"
                          layout="intrinsic"
                          data-testid="contentful_image-pulsepodcastmenuthumb"
                          sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw"
                          srcset="
                              https://images.ctfassets.net/vo9jqxsi4s22/6itMF91gBiBF1iM5HpY05b/45a8debed284e0cae0344795aa170a0e/pulse-podcast-menu-thumb.webp?w=350&q=75 350w,
                              https://images.ctfassets.net/vo9jqxsi4s22/6itMF91gBiBF1iM5HpY05b/45a8debed284e0cae0344795aa170a0e/pulse-podcast-menu-thumb.webp?w=384&q=75 384w,
                              https://images.ctfassets.net/vo9jqxsi4s22/6itMF91gBiBF1iM5HpY05b/45a8debed284e0cae0344795aa170a0e/pulse-podcast-menu-thumb.webp?w=750&q=75 750w,
                              https://images.ctfassets.net/vo9jqxsi4s22/6itMF91gBiBF1iM5HpY05b/45a8debed284e0cae0344795aa170a0e/pulse-podcast-menu-thumb.webp?w=1200&q=75 1200w
                            "
                            src="https://images.ctfassets.net/vo9jqxsi4s22/6itMF91gBiBF1iM5HpY05b/45a8debed284e0cae0344795aa170a0e/pulse-podcast-menu-thumb.webp?w=1200&q=75"
                            width="250"
                          height="250"
                          decoding="async"
                          data-nimg="future"
                          class="rounded-square linked"
                          loading="lazy"
                          style="color: transparent; max-width: 100px; height: auto; width: 100%; background-size: cover; background-position: 50% 50%; background-repeat: no-repeat; background-image: url(&quot;data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 250 250'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='20'/%3E%3C/filter%3E%3Cimage filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='/images/placeholder-image.png'/%3E%3C/svg%3E&quot;);"></picture
                    ></a>
                  </div> 
              <div>
                <a href="${window.newULifeConfig.marketDomain}/pulse/" class="mb--2"
                  >
                  <span class="mb--2">${this.discoverRef.reference2.fields.text2}</span>
                <picture class="mb--2 shadow--small"
                    ><img
                      alt="pulse-blog-menu-thumb"
                      layout="intrinsic"
                      data-testid="contentful_image-pulseblogmenuthumb"
                      sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw"
                      srcset="
                        https://images.ctfassets.net/vo9jqxsi4s22/4puWUogXzLHrgaz4SDbi7O/1859b442b8b12b60e14005d06578ea90/pulse-blog-menu-thumb.webp?w=350&q=75 350w,
                        https://images.ctfassets.net/vo9jqxsi4s22/4puWUogXzLHrgaz4SDbi7O/1859b442b8b12b60e14005d06578ea90/pulse-blog-menu-thumb.webp?w=384&q=75 384w,
                        https://images.ctfassets.net/vo9jqxsi4s22/4puWUogXzLHrgaz4SDbi7O/1859b442b8b12b60e14005d06578ea90/pulse-blog-menu-thumb.webp?w=750&q=75 750w,
                        https://images.ctfassets.net/vo9jqxsi4s22/4puWUogXzLHrgaz4SDbi7O/1859b442b8b12b60e14005d06578ea90/pulse-blog-menu-thumb.webp?w=1200&q=75 1200w
                      "
                      src="https://images.ctfassets.net/vo9jqxsi4s22/4puWUogXzLHrgaz4SDbi7O/1859b442b8b12b60e14005d06578ea90/pulse-blog-menu-thumb.webp?w=1200&q=75"
                      width="250"
                      height="250"
                      decoding="async"
                      data-nimg="future"
                      class="rounded-square linked"
                      loading="lazy"
                      style="color: transparent; max-width: 100px; height: auto; width: 100%; background-size: cover; background-position: 50% 50%; background-repeat: no-repeat; background-image: url(&quot;data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 250 250'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='20'/%3E%3C/filter%3E%3Cimage filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='/images/placeholder-image.png'/%3E%3C/svg%3E&quot;);"></picture
                ></a>
              </div>
            </div>
          </div>` : ''}
          ${
            educationWhitelist ? `
          <div class="row row--start gap--2">
            <h3 class="font--primary-dark">${this.discoverRef.reference3.fields.title}</h3>
            <ol class="row gap--2">
              <li><a href="${window.newULifeConfig.marketDomain}/science/">${this.discoverRef.reference3.fields.listArray[0].fields.textString}</a></li>
              <li><a href="${window.newULifeConfig.marketDomain}/somatech/">${this.discoverRef.reference3.fields.listArray[1].fields.textString}</a></li>
            </ol>
          </div>` : ''}
          <div class="row row--start gap--2">
            <h3 class="font--primary-dark">${this.discoverRef.reference4.fields.title}</h3>
            <ol class="row gap--2">
              <li><a href="${window.newULifeConfig.marketDomain}/ucare/">${this.discoverRef.reference4.fields.listArray[0].fields.textString}</a></li>
              <li><a href="${window.newULifeConfig.marketDomain}/ufund/">${this.discoverRef.reference4.fields.listArray[1].fields.textString}</a></li>
            </ol>
          </div>
        </div>
      </div>
    `
    
    const content = document.createElement('div');
    content.innerHTML += htmlContent;
    return content;
  }

  buildShopMenu() {
    const listArray = this.shopRef.reference1.fields.listArray
  
    const htmlContent = `
      <div class="mega-dropdown mega-dropdown__shop py--8 font--gray" data-style="width: 18rem;">
        <div class="display-grid page-width columns__1-3 column--spaced gap--8">
          <div class="row">
            <h3 class="font--primary-dark">${this.shopRef.title}</h3>
            <p class="font--gray-light">${this.shopRef.description}</p>
            <ol>
              <li>
                <a class="nav-button" href="${window.newULifeConfig.currentShopUrl}">
                  <button class="button">${this.shopRef.buttonText1}</button>
                </a>
              </li>
            </ol>
          </div>
          <div class="row gap--2 pt--6">
            <div class="column gap--4 text--transform-uppercase">
              <div>
                <ol class="row gap--2 row--start">
                  ${listArray.map(({ fields }) => {
                    var isWhitelisted = !fields?.whitelistedMarkets || fields?.whitelistedMarkets?.some(market => market === window.newULifeConfig.currentMarketData.value);
                    if (!isWhitelisted) return '';
                    return `
                    <li class="${fields.buttonName === 'Rose & Cole' ? 'column column--start row--center gap--0-5' : ''}">
                      <a 
                        ${fields.buttonName === 'Rose & Cole' ? '' : 'class="outlined"'} 
                        href="${this.getShopLinkUrl(fields)}"
                      >
                        ${fields.buttonName}
                      </a>
                    </li>
                  `;
                  }).join('')}
                </ol>
              </div>
              <div class="column column--end">
                <picture class="mb--2 shadow--small">
                  <img
                    alt="Image of woman at computer"
                    src="https://images.ctfassets.net/vo9jqxsi4s22/1AbfVHJWZ9UdifAVKn4mcx/3dd21691318108143c4cc2d355cf3428/woman-at-computer.webp"
                    class="linked"
                    style="max-width:500px; height: auto; width: 100%; border-radius: 10px;"
                  >
                </picture>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  
    const content = document.createElement('div');
    content.innerHTML += htmlContent;
    return content;
  }

  buildEarnMenu() {
    const htmlContent = `
      <div class="mega-dropdown py--8 font--gray" data-style="width: 18rem;">
        <div class="page-width column column--center columns__2 row gap--8">
          <div class="row gap--1">
            <h3 class="mb--2 font--primary-dark">${this.earnRef.reference1.fields.title}</h3>
            <p class="mb--4">${this.earnRef.reference1.fields.description}</p>
            <div class="column gap--2 column--start">
              <a class="no-underline" href="${window.newULifeConfig.marketDomain}/earn-with-us/">
                <button class="button font--inverse">${this.earnRef.reference1.fields.buttonText1}</button>
              </a>
              <a class="no-underline" target="_blank" href="https://enroll.newulife.com/">
                <button class="button outlined">${this.earnRef.reference1.fields.buttonText2}</button>
              </a>
            </div>
          </div>
          <picture class="img--full">
            <img
              alt="image of parents with kids laughing together"
              src="https://images.ctfassets.net/vo9jqxsi4s22/WC6QJ58jc0hbR8s9RC4GE/3277e4850c239abddd486d196705fb47/family-member.webp"
              loading="lazy"
              style="color: transparent; height: auto; width: 100%;"
            >
          </picture>
        </div>
      </div>
    `;

    const content = document.createElement('div');
    content.innerHTML += htmlContent;
    return content;
  }

  buildSelectMarket() {
    return `
      <div class="scrim">
        <div class="modal-wrapper">
          <div class="modal" style="--modal-max-width: 670px; display: block;">
            <div class="modal__close">
              <svg width="24px" height="24px" class="icon--medium icon--palette_neutral-400" viewBox="0 0 320 512">
                <path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"></path>
              </svg>
            </div>
            <div class="py--6 px--2 md--px--6">
              <h3 class="font__title2 text--transform-uppercase font--gray-light font--semibold font--center mb--1">
                Select Your Market
              </h3>
              <hr class="mb--3">
              <div class="row column--center mb--4">
                <div class="display-grid md--columns__2 gap--1" style="column-gap: 100px;">
                  ${window.newULifeConfig.markets.map((o) => {
                    const isLiveMarket = this.liveShopifyMarkets.some((market) => market === o.name);
                    return `
                      <a
                        ${isLiveMarket ? '' : `href="${window.newULifeConfig.bydesignStoreHref}"`}
                        class="font__largeBody font--semibold font--gray selectable font--height-2"
                        style="color: var(--text-dark);"
                        data-market="${o.value}"
                        data-isLiveMarket="${isLiveMarket}"
                      >
                        ${o.name}
                      </a>
                    `;
                  }).join('')}
                </div>
              </div>
              <div id="desktop-select-language"></div>
            </div>
          </div>
        </div>
      </div>
    `
  }

  buildSelectLanguage() {
    const shopifyRootUrl = window.newULifeConfig.langSelectorMarket.shopifyUrl || '';
    const marketSelectionLanguages = window.newULifeConfig.langSelectorMarket.languages;

    return `
      <div>
        <hr class="mb--3">
        <h3 class="font__title2 text--transform-uppercase font--gray-light font--semibold font--center mb--1">
          Select Your Language
        </h3>
        <div class="row column--center">
          <div class="row gap--1">
            ${marketSelectionLanguages.map(o => `
              <a 
                class="font__largeBody font--semibold font--gray hover--primary selectable" 
                style="color: var(--text-dark);"
                href="${this.buildLanguageTargetUrl(o.shopifyHref, shopifyRootUrl)}"
                data-language-market="${window.newULifeConfig.langSelectorMarket.name}"
              >
                ${o.name}
              </a>
            `).join('')}
          </div>
        </div>
      </div>
    `
  }

  addDesktopEventListeners() {
    document.getElementById('desktop-select-market').addEventListener('click', e => {
      const div = document.createElement('div');
      div.id = 'desktop-select-market-modal';
      div.innerHTML += this.buildSelectMarket();
      document.body.appendChild(div);
      
      div.querySelectorAll('[data-market]').forEach(el => {
        const marketValue = el.getAttribute('data-market');
        const isLiveMarket = el.getAttribute('data-isLiveMarket');
        const languageSelectorElement = document.getElementById('desktop-select-language');
        
          el.addEventListener('click', event => {
            if(isLiveMarket === 'true'){
              window.newULifeConfig.markets.forEach(o => {
                if (o.value === marketValue) window.newULifeConfig.langSelectorMarket = o;
              })
              
              div.querySelectorAll('[data-market]').forEach(el1 => {
                el1.style.color = 'var(--text-dark)';
              })
              el.style.color = 'var(--primary)';
              
              languageSelectorElement.innerHTML = this.buildSelectLanguage();

              languageSelectorElement.querySelectorAll('[data-language-market]').forEach(el => {
                el.addEventListener('click', e => {
                  var languageMarket = e.target.getAttribute('data-language-market');
                  var languageHref = e.target.getAttribute('href');
                  var redirectPath = new URL(languageHref).pathname + new URL(languageHref).search;
                  var customerEmail = window.customerEmail;
                  if (!!customerEmail && languageMarket) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.marketChangeForCustomer(languageMarket, redirectPath);
                  } 
                })
              });

              const languageSection = document.getElementById('desktop-select-language');
              if (languageSection) {
                languageSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              
            } else {
              if (!!window?.customerInfoMetafields?.customerId && window?.customerInfoMetafields?.customerType === "representative") {
                event.preventDefault();
                event.stopPropagation();
                this.redirectToNonShopifyMarket(
                  window.newULifeConfig.bydesignStoreHref,
                  marketValue,
                  window?.customerInfoMetafields?.customerType
                );
              }
              languageSelectorElement.innerHTML = '';
            }
          });
      })

      const scrim = div.querySelector('.scrim'); // Assuming scrim has the class 'scrim'
      if (scrim) {
        scrim.addEventListener('click', () => {
          document.getElementById('desktop-select-market-modal').remove();
        });
      }

      const modal = div.querySelector('.modal'); // Assuming modal has the class 'modal'
      if (modal) {
        modal.addEventListener('click', (event) => {
          event.stopPropagation(); // Stops the event from bubbling up to the scrim
        });
      }
      
      document.querySelectorAll('.modal__close').forEach(el => {
        el.addEventListener('click', e => {
          document.getElementById('desktop-select-market-modal').remove();
        });
      });
    });

    // Add click handler for top bar language links
    document.querySelectorAll('[data-is-topbar="true"]').forEach(el => {
      el.addEventListener('click', e => {
        // For top bar links, prevent the marketChangeForCustomer from firing
        e.stopPropagation();
        // Let the default navigation happen
      });
    });
  }

  // MOBILE MENU

  buildMobileMenu() {
    const htmlContent = `
      <header>
        <div class="header-mobile column column--spaced row--center gap--2">
          <a href="/">
            <img src="https://images.ctfassets.net/vo9jqxsi4s22/169zOU6TxfIQkk6pt6zaRj/afdbd423614f13a88d7315032ca01967/mobile-logo.svg" alt="New U Life Logo" class="header-mobile__left">
          </a>
          <a data-testid="mobile-menuClose" class="header-mobile__right header--close">
            <svg width="24px" height="24px" class="icon--medium icon--palette_neutral-400" viewBox="0 0 320 512">
              <path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"></path>
            </svg>
          </a>
        </div>
      </header>
      <div class="header-menu">`
        // <div class="null MobileMenu_topbar_border__xVrnf column font--center gap--2 bg--white px--4 py--1">
        //   <a class="login font--bold font--primary" href="https://dash.newulife.com">${this.menuRef.text8}</a>
        // </div>
        +`
        <div id="mobile-menu_content">
          ${this.showMobile_TopMenu()}
        </div>
        
        <div class="header-menu__scrim"></div>

        <div id="header-menu__select"></div>
        
        <footer id="mobile-footer" class="footer-mobile">
          ${this.showMobile_Footer()}
        </footer>
      </div>
    `
    const mobileDrawerElement = document.getElementById('mobile-menu');
    mobileDrawerElement.innerHTML += htmlContent;

    this.addMobileEventListeners();
  }

  showMobile_TopMenu() {
    const menu = [
      { show: 'OurStory', label: this.menuRef.text1 },
      // { show: 'Products', label: this.menuRef.text2 },
      { show: 'Discover', label: this.menuRef.text3 },
      { show: 'Shop', label: this.menuRef.text4 },
      { show: 'Earn', label: this.menuRef.text5 },
    ]
    return `
      <div class="header-menu__content">
        <div class="header-menu__content-navigation">
          <div class="header-menu__nav">
            ${menu.map(o => `
              <div class="header-menu__nav-item header-menu__nav-item--next" data-show="${o.show}">
                <a>${o.label}</a>
              </div>
            `).join('')}
          </div>
        </div>
      </div>
    `
  }

  showMobile_OurStory() {
    return `
      <div class="header-menu__content">
        <div class="header-menu__back header-menu__nav-item--previous" data-show="TopMenu">
          <a>${this.menuRef.buttonText1}</a>
        </div>
        <div class="header-menu__content-navigation">
          <div class="row gap--1">
            <div class="header-menu__page-name">${this.ourStoryRef.title}</div>
          </div>
          <div class="header-menu__nav">
            <div class="header-menu__nav-item header-menu__nav-item--next" data-show="OurStory_1">
              <a data-testid="WhoWeAre">${this.ourStoryRef.reference1.fields.title}</a>
            </div>
            <div class="header-menu__nav-item header-menu__nav-item--next mb--1" data-show="OurStory_2">
              <a data-testid="WhatWeDo">${this.ourStoryRef.reference2.fields.title}</a>
            </div>
          </div>
          <div class="row gap--3">
            <div class="row gap--1">
              <div class="font__largeBody font--gray-lighter font--semibold text--transform-uppercase">
                ${this.ourStoryRef.reference1.fields.reference1.fields.title}
              </div>
              <div class="font__largeBody font--gray-medium">
                ${this.ourStoryRef.reference4.fields.item1}
              </div>
            </div>
            <div class="iframe-outer">
              <div class="embed-container">
                <iframe src="${this.ourStoryRef.reference4.fields.videoUrl}" width="auto" frameborder="0" allow="fullscreen"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  }

  showMobile_OurStory_1() {
    return `
      <div class="header-menu__content">
        <div class="header-menu__back header-menu__nav-item--previous" data-show="OurStory">
          <a>${this.menuRef.buttonText1}</a>
        </div>
        <div class="header-menu__content-navigation">
          <div class="row gap--5">
            <div class="row gap--1">
              <div class="header-menu__page-name">
                ${this.ourStoryRef.reference1.fields.title}
              </div>
              <div class="font__largeBody font--gray-medium">
                ${this.ourStoryRef.reference1.fields.description}
              </div>
            </div>
            <div class="row gap--3">
              <div class="font__title3 text--transform-uppercase font--gray-lighter font--bold">
              ${this.ourStoryRef.reference1.fields.reference1.fields.title}
              </div>
              <div class="row gap--2">
                <div class="header-menu__nav-item">
                  <a data-testid="Leadership" href="${window.newULifeConfig.marketDomain}/leadership/">${this.ourStoryRef.reference1.fields.reference1.fields.listArray[0].fields.textString}</a>
                </div>
                <div class="header-menu__nav-item">
                  <a data-testid="Company" href="${window.newULifeConfig.marketDomain}/company/">${this.ourStoryRef.reference1.fields.reference1.fields.listArray[1].fields.textString}</a>
                </div>
                <div class="header-menu__nav-item">
                  <a data-testid="Whatwestandfor" href="${window.newULifeConfig.marketDomain}/mission-vision-values/">${this.ourStoryRef.reference1.fields.reference1.fields.listArray[2].fields.textString}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  }

  showMobile_OurStory_2() {
    return `
      <div class="header-menu__content">
        <div class="header-menu__back header-menu__nav-item--previous" data-show="OurStory">
          <a>${this.menuRef.buttonText1}</a>
        </div>
        <div class="header-menu__content-navigation">
          <div class="row gap--5">
            <div class="row gap--1">
              <div class="header-menu__page-name">
                ${this.ourStoryRef.reference2.fields.title}
              </div>
              <div class="font__largeBody font--gray-medium">
                ${this.ourStoryRef.reference2.fields.description}
              </div>
            </div>
            <div class="row gap--3">
              <div class="font__title3 text--transform-uppercase font--gray-lighter font--bold">
                ${this.ourStoryRef.reference2.fields.reference1.fields.title}
              </div>
              <div class="row gap--2">
                <div class="header-menu__nav-item">
                  <a data-testid="Whatarehormones?" href="${window.newULifeConfig.marketDomain}/what-are-hormones/">${this.ourStoryRef.reference2.fields.reference1.fields.listArray[0].fields.textString}</a>
                </div>
                <div class="header-menu__nav-item">
                  <a data-testid="ImprovingMetabolism" href="${window.newULifeConfig.marketDomain}/improving-metabolism/">${this.ourStoryRef.reference2.fields.reference1.fields.listArray[1].fields.textString}</a>
                </div>
                <div class="header-menu__nav-item">
                  <a data-testid="InnovativeAnti-Aging" href="${window.newULifeConfig.marketDomain}/innovative-anti-aging/">${this.ourStoryRef.reference2.fields.reference1.fields.listArray[2].fields.textString}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  }

  showMobile_Products() {
    return `
      <div class="header-menu__content">
          <div class="header-menu__back header-menu__nav-item--previous" data-show="TopMenu">
              <a>${this.menuRef.buttonText1}</a>
          </div>
          <div class="header-menu__content-navigation">
              <div class="row gap--5">
                  <div class="row gap--1">
                      <div class="header-menu__page-name">${this.productsRef.title}</div>
                      <div class="row column--center">
                          <img 
                            alt="products" 
                            layout="intrinsic" 
                            sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw" 
                            srcset="https://newulife.com/_next/image/?url=%2Fimages%2Fproducts%2Fnul-products-us.webp&amp;w=350&amp;q=75 350w, 
                                    https://newulife.com/_next/image/?url=%2Fimages%2Fproducts%2Fnul-products-us.webp&amp;w=384&amp;q=75 384w, 
                                    https://newulife.com/_next/image/?url=%2Fimages%2Fproducts%2Fnul-products-us.webp&amp;w=750&amp;q=75 750w, 
                                    https://newulife.com/_next/image/?url=%2Fimages%2Fproducts%2Fnul-products-us.webp&amp;w=1200&amp;q=75 1200w" 
                            src="https://newulife.com/_next/image/?url=%2Fimages%2Fproducts%2Fnul-products-us.webp&amp;w=1200&amp;q=75" 
                            width="250" height="250" decoding="async" data-nimg="future" loading="lazy" 
                            style="color: transparent; height: auto; width: 100%;"
                          >
                      </div>
                  </div>
                  <div class="row gap--3">
                      <div class="row gap--2 pb--4">
                        ${this.productsRef.reference1.fields.listArray.map(({ fields }) => 
                          `<div class="header-menu__nav-item"><a href="${this.removeSuffixIfWholesale(fields.url)}">${fields.buttonName}</a></div>`
                        ).join('')}
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `
  }

  showMobile_Discover() {
    var currentMarketCountry = window.newULifeConfig.currentCountry === "USA" ? "United States" : window.newULifeConfig.currentCountry;
    var blogPodcastWhitelist = this.discoverRef.reference2.fields.whitelist.some((market) => { return market === currentMarketCountry });
    var educationWhitelist = this.discoverRef.reference5.fields.whitelist.some((market) => { return market === currentMarketCountry });

    return `
      <div class="header-menu__content">
          <div class="header-menu__back header-menu__nav-item--previous" data-show="TopMenu">
              <a>${this.menuRef.buttonText1}</a>
          </div>
          <div class="header-menu__content-navigation">
              <div class="row gap--3">
                  <div class="row">
                      <div class="header-menu__page-name">${this.discoverRef.title}</div>
                  </div>
                  <div class="row gap--3">
                      <div class="row gap--2 pb--4">
                          <div class="header-menu__nav-item header-menu__nav-item--next" data-show="Discover_1">
                              <a data-testid="Events">${this.discoverRef.reference1.fields.title}</a>
                          </div>
                          <div class="header-menu__nav-item header-menu__nav-item--next" data-show="Discover_2">
                              <a data-testid="Community">${this.discoverRef.reference4.fields.title}</a>
                          </div>
                          ${educationWhitelist ? `
                          <div class="header-menu__nav-item header-menu__nav-item--next mb--1" data-show="Discover_3">
                              <a data-testid="Education">${this.discoverRef.reference3.fields.title}</a>
                          </div>` : '' }
                          ${ blogPodcastWhitelist ? `
                          <hr>
                          <div>
                              <div class="header-menu__image-slider-image mb--2">
                                  <a href="${window.newULifeConfig.marketDomain}/podcast/">
                                      <p class="header-menu__nav-item">${this.discoverRef.reference2.fields.text1}</p>
                                      <img 
                                        alt="pulse-podcast-menu-thumb" 
                                        layout="intrinsic" 
                                        data-testid="contentful_image-pulsepodcastmenuthumb" 
                                        sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw"
                                        srcset="
                                          https://images.ctfassets.net/vo9jqxsi4s22/6itMF91gBiBF1iM5HpY05b/45a8debed284e0cae0344795aa170a0e/pulse-podcast-menu-thumb.webp?w=350&q=75 350w,
                                          https://images.ctfassets.net/vo9jqxsi4s22/6itMF91gBiBF1iM5HpY05b/45a8debed284e0cae0344795aa170a0e/pulse-podcast-menu-thumb.webp?w=384&q=75 384w,
                                          https://images.ctfassets.net/vo9jqxsi4s22/6itMF91gBiBF1iM5HpY05b/45a8debed284e0cae0344795aa170a0e/pulse-podcast-menu-thumb.webp?w=750&q=75 750w,
                                          https://images.ctfassets.net/vo9jqxsi4s22/6itMF91gBiBF1iM5HpY05b/45a8debed284e0cae0344795aa170a0e/pulse-podcast-menu-thumb.webp?w=1200&q=75 1200w
                                        "
                                        src="https://images.ctfassets.net/vo9jqxsi4s22/6itMF91gBiBF1iM5HpY05b/45a8debed284e0cae0344795aa170a0e/pulse-podcast-menu-thumb.webp?w=1200&q=75"
                                        width="250" 
                                        height="250" 
                                        decoding="async" 
                                        data-nimg="future" 
                                        class="rounded-square" 
                                        loading="lazy" 
                                        style="color: transparent; height: auto; width: 100%;"
                                      >
                                  </a>
                              </div>
                              <div class="header-menu__image-slider-image mb--2">
                                  <a href="${window.newULifeConfig.marketDomain}/pulse/">
                                      <p class="header-menu__nav-item">${this.discoverRef.reference2.fields.text2}</p>
                                      <img 
                                        alt="pulse-blog-menu-thumb" 
                                        layout="intrinsic" 
                                        data-testid="contentful_image-pulseblogmenuthumb" 
                                        sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw"
                                        srcset="
                                          https://images.ctfassets.net/vo9jqxsi4s22/4puWUogXzLHrgaz4SDbi7O/1859b442b8b12b60e14005d06578ea90/pulse-blog-menu-thumb.webp?w=350&q=75 350w,
                                          https://images.ctfassets.net/vo9jqxsi4s22/4puWUogXzLHrgaz4SDbi7O/1859b442b8b12b60e14005d06578ea90/pulse-blog-menu-thumb.webp?w=384&q=75 384w,
                                          https://images.ctfassets.net/vo9jqxsi4s22/4puWUogXzLHrgaz4SDbi7O/1859b442b8b12b60e14005d06578ea90/pulse-blog-menu-thumb.webp?w=750&q=75 750w,
                                          https://images.ctfassets.net/vo9jqxsi4s22/4puWUogXzLHrgaz4SDbi7O/1859b442b8b12b60e14005d06578ea90/pulse-blog-menu-thumb.webp?w=1200&q=75 1200w
                                        "
                                        src="https://images.ctfassets.net/vo9jqxsi4s22/4puWUogXzLHrgaz4SDbi7O/1859b442b8b12b60e14005d06578ea90/pulse-blog-menu-thumb.webp?w=1200&q=75"
                                        width="250"
                                        height="250" 
                                        decoding="async" 
                                        data-nimg="future" 
                                        class="rounded-square" 
                                        loading="lazy" 
                                        style="color: transparent; height: auto; width: 100%;"
                                      >
                                  </a>
                              </div>
                          </div>` : ''}
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `
  }

  showMobile_Discover_1() {
    return `
      <div class="header-menu__content">
          <div class="header-menu__back header-menu__nav-item--previous" data-show="Discover">
              <a>${this.menuRef.buttonText1}</a>
          </div>
          <div class="header-menu__content-navigation">
              <div class="row gap--3">
                  <div class="row">
                      <div class="header-menu__page-name">${this.discoverRef.reference1.fields.title}</div>
                  </div>
                  <div class="row gap--3">
                      <div class="row gap--2">
                          <div class="header-menu__nav-item">
                              <a data-testid="Jamaica2024" href="${window.newULifeConfig.marketDomain}${this.discoverRef.reference1.fields.listArray[0].fields.href}">${this.discoverRef.reference1.fields.listArray[0].fields.textString}</a>
                          </div>
                          <div class="header-menu__nav-item">
                              <a data-testid="AllEvents" href="${window.newULifeConfig.marketDomain}${this.discoverRef.reference1.fields.listArray[1].fields.href}">${this.discoverRef.reference1.fields.listArray[1].fields.textString}</a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `
  }

  showMobile_Discover_2() {
    return `
      <div class="header-menu__content">
          <div class="header-menu__back header-menu__nav-item--previous" data-show="Discover">
              <a>${this.menuRef.buttonText1}</a>
          </div>
          <div class="header-menu__content-navigation">
              <div class="row gap--3">
                  <div class="row">
                      <div class="header-menu__page-name">${this.discoverRef.reference4.fields.title}</div>
                  </div>
                  <div class="row gap--3">
                      <div class="row gap--2">
                          <div class="header-menu__nav-item">
                              <a data-testid="UCare" href="${window.newULifeConfig.marketDomain}/ucare/">${this.discoverRef.reference4.fields.listArray[0].fields.textString}</a>
                          </div>
                          <div class="header-menu__nav-item">
                              <a data-testid="UFund" href="${window.newULifeConfig.marketDomain}/ufund/">${this.discoverRef.reference4.fields.listArray[1].fields.textString}</a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `
  }

  showMobile_Discover_3() {
    return `
      <div class="header-menu__content">
          <div class="header-menu__back header-menu__nav-item--previous" data-show="Discover">
              <a>${this.menuRef.buttonText1}</a>
          </div>
          <div class="header-menu__content-navigation">
              <div class="row gap--3">
                  <div class="row">
                      <div class="header-menu__page-name">${this.discoverRef.reference3.fields.title}</div>
                  </div>
                  <div class="row gap--3">
                      <div class="row gap--2">
                          <div class="header-menu__nav-item">
                              <a data-testid="TheScience" href="${window.newULifeConfig.marketDomain}/science/">${this.discoverRef.reference3.fields.listArray[0].fields.textString}</a>
                          </div>
                          <div class="header-menu__nav-item">
                              <a data-testid="SomaTech" href="${window.newULifeConfig.marketDomain}/somatech/">${this.discoverRef.reference3.fields.listArray[1].fields.textString}</a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `
  }

  showMobile_Shop() {
    return `
      <div class="header-menu__content">
          <div class="header-menu__back header-menu__nav-item--previous" data-show="TopMenu">
              <a>${this.menuRef.buttonText1}</a>
          </div>
          <div class="header-menu__content-navigation">
              <div class="row gap--5 pb--4">
                  <div class="row gap--2">
                      <div class="header-menu__page-name">${this.shopRef.title}</div>
                      <div class="row column--start">
                        <img
                          alt="Woman at computer"
                          src="https://images.ctfassets.net/vo9jqxsi4s22/1AbfVHJWZ9UdifAVKn4mcx/3dd21691318108143c4cc2d355cf3428/woman-at-computer.webp"
                          class="linked"
                          style="max-width:500px; height: auto; width: 100%; border-radius: 10px;"
                        >
                      </div>
                  </div>
                  <div class="row gap--3">
                      <div class="row gap--2">
                          ${this.shopRef.reference1.fields.listArray.map(({ fields }, idx) => {
                            var isWhitelisted = !fields.whitelistedMarkets || fields.whitelistedMarkets.some(market => market === window.newULifeConfig.currentMarketData.value);
                            if (!isWhitelisted) return '';
                            
                            return fields.title === 'rose' ? `
                            <div class="header-menu__nav-item header-menu__nav-item--next" data-show="Shop_1">
                              ${fields.buttonName}
                            </div>
                          ` : `
                            <div class="header-menu__nav-item">
                                <a class="outlined" href="${this.getShopLinkUrl(fields)}">
                                    ${fields.buttonName}
                                </a>
                            </div>
                          `;
                          }).join('')}
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `
  }

  showMobile_Shop_1() {
    //Not used in the current design
    return `
      <div class="header-menu__content">
          <div class="header-menu__back header-menu__nav-item--previous" data-show="Shop">
              <a>${this.menuRef.buttonText1}</a>
          </div>
          <div class="header-menu__content-navigation">
              <div class="row gap--5">
                  <div class="row gap--1">
                      <div class="header-menu__page-name font--rose">
                        ${this.shopRef.reference2.fields.title}
                      </div>
                      <div class="row column--center">
                          <img alt="shop-item-preview" layout="intrinsic" data-testid="contentful_image-shopitempreview" 
                              sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw" 
                              srcset="https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=350&amp;q=75 350w, 
                                      https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=384&amp;q=75 384w, 
                                      https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=750&amp;q=75 750w, 
                                      https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=1200&amp;q=75 1200w" 
                              src="https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=1200&amp;q=75" 
                              width="250" height="250" decoding="async" data-nimg="future" loading="lazy" 
                              style="color: transparent; height: auto; width: 100%;">
                      </div>
                  </div>
                  <div class="row gap--3">
                      <div class="row gap--2">
                          <div class="header-menu__nav-item header-menu__nav-item--next" data-show="Shop_1_1">
                            ${this.shopRef.reference2.fields.reference1.fields.title}
                          </div>
                          <div class="header-menu__nav-item header-menu__nav-item--next" data-show="Shop_1_2">
                            ${this.shopRef.reference2.fields.reference2.fields.title}
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `
  }

  showMobile_Shop_1_1() {
    //Not used anymore
    return `
      <div class="header-menu__content">
          <div class="header-menu__back header-menu__nav-item--previous" data-show="Shop_1">
              <a>${this.menuRef.buttonText1}</a>
          </div>
          <div class="header-menu__content-navigation">
              <div class="row gap--5">
                  <div class="row gap--1">
                      <div class="header-menu__page-name font--rose">
                        ${this.shopRef.reference2.fields.title}
                      </div>
                      <div class="row column--center">
                          <img alt="shop-item-preview" layout="intrinsic" data-testid="contentful_image-shopitempreview" 
                              sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw" 
                              srcset="https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=350&amp;q=75 350w, 
                                      https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=384&amp;q=75 384w, 
                                      https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=750&amp;q=75 750w, 
                                      https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=1200&amp;q=75 1200w" 
                              src="https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=1200&amp;q=75" 
                              width="250" height="250" decoding="async" data-nimg="future" loading="lazy" 
                              style="color: transparent; height: auto; width: 100%;">
                      </div>
                  </div>
                  <div class="row gap--3">
                      <div class="row gap--2">
                          <div class="header-menu__nav-item">
                              <a 
                                class="outlined" 
                                href="${this.getShopLinkUrl(this.shopRef.reference2.fields.reference1.fields.listArray[0].fields)}"
                              >
                                ${this.shopRef.reference2.fields.reference1.fields.listArray[0].fields.buttonName}
                              </a>
                          </div>
                          <div class="header-menu__nav-item">
                              <a 
                                class="outlined" 
                                href="${this.getShopLinkUrl(this.shopRef.reference2.fields.reference1.fields.listArray[1].fields)}"
                              >
                                ${this.shopRef.reference2.fields.reference1.fields.listArray[1].fields.buttonName}
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `
  }

  showMobile_Shop_1_2() {
    // Not used anymore
    return `
      <div class="header-menu__content">
          <div class="header-menu__back header-menu__nav-item--previous" data-show="Shop_1">
              <a>${this.menuRef.buttonText1}</a>
          </div>
          <div class="header-menu__content-navigation">
              <div class="row gap--5">
                  <div class="row gap--1">
                      <div class="header-menu__page-name font--rose">
                        ${this.shopRef.reference2.fields.title}
                      </div>
                      <div class="row column--center">
                          <img alt="shop-item-preview" layout="intrinsic" data-testid="contentful_image-shopitempreview" 
                              sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw" 
                              srcset="https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=350&amp;q=75 350w, 
                                      https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=384&amp;q=75 384w, 
                                      https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=750&amp;q=75 750w, 
                                      https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=1200&amp;q=75 1200w" 
                              src="https://newulife.com/_next/image/?url=https%3A%2F%2Fimages.ctfassets.net%2F96ftuyamizgy%2F5lgIHlWR5WwnErJGcVB3wc%2Fa50cc51223183a2730278c7814892ea7%2Fshop-item-preview.png&amp;w=1200&amp;q=75" 
                              width="250" height="250" decoding="async" data-nimg="future" loading="lazy" 
                              style="color: transparent; height: auto; width: 100%;">
                      </div>
                  </div>
                  <div class="row gap--3">
                      <div class="row gap--2">
                          ${this.shopRef.reference2.fields.reference2.fields.listArray.map(({ fields }) => `
                            <div class="header-menu__nav-item">
                              <a 
                                class="outlined" 
                                href="${this.getShopLinkUrl(fields)}"
                              >
                                ${fields.buttonName}
                              </a>
                            </div>
                          `).join('')}
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `
  }

  showMobile_Earn() {
    return `
      <div class="header-menu__content">
          <div class="header-menu__back header-menu__nav-item--previous" data-show="TopMenu">
              <a>${this.menuRef.buttonText1}</a>
          </div>
          <div class="header-menu__content-navigation">
              <div class="row gap--3">
                  <div class="row gap--2">
                      <div class="header-menu__page-name">${this.earnRef.title}</div>
                      <div class="row column--center">
                      <img
                        alt="image of parents with kids laughing together"
                        src="https://images.ctfassets.net/vo9jqxsi4s22/WC6QJ58jc0hbR8s9RC4GE/3277e4850c239abddd486d196705fb47/family-member.webp"
                        loading="lazy"
                        style="color: transparent; height: auto; width: 100%;"
                      >
                      </div>
                  </div>
                  <div class="row gap--3">
                      <div class="row gap--1">
                          <div class="header-menu__nav-item">
                            ${this.earnRef.reference1.fields.title}
                          </div>
                          <div class="font__largeBody font--gray-medium mb--3">
                              ${this.earnRef.reference1.fields.description}
                          </div>
                          <div class="row gap--2 column--center">
                              <a href="${window.newULifeConfig.marketDomain}/earn-with-us/">
                                  <button class="font--semibold" data-testid="earn-button">
                                    ${this.earnRef.reference1.fields.buttonText1}
                                  </button>
                              </a>
                              <a class="button outlined" target="_blank" href="https://enroll.newulife.com/">
                                  ${this.earnRef.reference1.fields.buttonText2}
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `
  }

  showMobile_Footer() {
    return `
      <div class="header-menu__language-selector" data-showfooter="FooterActive">
        <div class="header-menu__language">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" style="height: 12px;">
            <title>${window.newULifeConfig.currentCountry}</title>
            <path fill="#FFF" d="M0 0h513v342H0z"></path>
            <path d="M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z" fill="#D80027"></path>
            <path fill="#2E52B2" d="M0 0h256.5v184.1H0z"></path>
            <path d="m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z" fill="#FFF"></path>
          </svg>
          <p data-testid="activeMarketLanguage" class="font__subheader font--gray-medium text--transform-uppercase">
            ${window.newULifeConfig.currentCountry} <strong>|</strong> ${window.newULifeConfig.currentLanguageName}
          </p>
          <img class="icon--xsmall" src="https://newulife.com/images/chevron-up.svg">
        </div>
      </div>
    `
  }

  showMobile_FooterActive() {
    return `
      <div class="header-menu__language-selector">
        <div class="header-menu__language-dropdown">
          <div class="row gap--1 p--2 font--center">
            <div class="font__largeBody font--gray-medium">${window.newULifeConfig.currentCountry}</div>
            <div class="row gap--1">
              ${window.newULifeConfig.availableLanguages.map((isoCode) => {
                const language = window.newULifeConfig.activeMarketLanguages.find((lang) => lang.shopifyValue === isoCode);

                if (language) {
                return `
                  <a 
                    href="${this.buildLanguageTargetPath(language.shopifyHref)}" 
                    class="header-menu__language-item" 
                    data-language="${language.contentfulValue}"
                    data-language-market="${window.newULifeConfig.currentCountry}"
                  >
                    ${language.name}
                  </a>
                `;
                }
              return '';
              }).join('')}
            </div>
          </div>
          <hr class="blend">
          <a>
            <div class="column column--center gap--1 p--2 font--center selectable" data-showselector="SelectMarket">
              <svg class="w-6 h-6" viewBox="0 0 27 27"><path fill-rule="evenodd" clip-rule="evenodd" fill="currentColor" d="M15.5063 24.1063C15.7929 23.3896 16.3663 22.8163 16.7963 22.3863C17.2263 22.0996 17.7996 21.3829 17.9429 20.9529C18.0863 20.3796 18.5163 19.9496 18.8029 19.5196C19.2329 18.8029 17.7996 17.7996 17.2263 17.6563C16.0796 17.2263 15.3629 16.5096 14.3596 15.9363C13.6429 15.5063 12.3529 16.2229 11.4929 15.7929C10.4896 15.3629 9.62961 14.5029 8.62628 13.7863C7.62294 13.0696 7.76628 12.2096 7.76628 11.2063C8.48294 11.2063 9.62961 11.0629 10.0596 11.6363C10.2029 11.7796 10.7763 12.6396 11.0629 12.3529C11.3496 12.0663 10.9196 11.0629 10.7763 10.9196C10.4896 10.2029 11.4929 9.91628 11.9229 9.48628C12.6396 8.91294 13.9296 7.90961 13.9296 7.47961C13.7863 7.04961 12.4963 5.75961 11.7796 5.90294C11.6363 5.90294 10.6329 7.04961 10.4896 7.19294C10.4896 6.90628 10.4896 6.47628 10.4896 6.18961C10.4896 6.04628 10.0596 5.75961 10.0596 5.61628C10.0596 5.32961 11.0629 4.61294 11.3496 4.32628C11.2063 4.18294 10.6329 3.75294 10.3463 3.75294C9.91628 3.89628 9.48628 4.03961 9.05628 4.18294C9.05628 4.03961 9.05628 3.89628 9.05628 3.89628C9.91628 3.46628 10.9196 3.17961 11.9229 3.03628L12.6396 3.32294L13.2129 4.03961L13.7863 4.61294L14.3596 4.75628L15.2196 3.89628L15.0763 3.32294V2.89294C16.6529 3.17961 18.2296 3.75294 19.5196 4.61294C19.2329 4.61294 19.0896 4.61294 18.8029 4.75628C18.6596 4.61294 18.5163 4.61294 18.3729 4.61294C18.8029 5.47294 19.2329 6.33294 19.6629 7.19294C20.0929 8.05294 21.0963 9.05628 21.2396 10.0596C21.3829 11.2063 21.2396 12.2096 21.3829 13.4996C21.5263 14.7896 22.8163 16.2229 22.8163 16.2229C22.8163 16.2229 23.3896 16.3663 23.8196 16.3663C22.8163 20.2363 19.6629 23.2463 15.5063 24.1063ZM12.2096 24.1063C6.76294 23.5329 2.74961 18.9463 2.74961 13.4996C2.74961 10.9196 3.75294 8.48294 5.32961 6.61961C5.32961 7.04961 5.47294 7.62294 5.47294 7.90961C5.32961 9.34294 5.18628 10.2029 6.04628 11.4929C6.33294 11.9229 6.47628 12.6396 6.61961 13.2129C6.76294 13.7863 7.47961 14.0729 7.90961 14.3596C8.76961 15.0763 9.62961 15.7929 10.4896 16.3663C11.0629 16.7963 11.4929 16.9396 11.3496 17.6563C11.2063 18.2296 11.2063 18.6596 10.7763 19.0896C10.6329 19.2329 11.0629 20.3796 11.3496 20.5229C11.7796 20.9529 12.2096 21.3829 12.7829 21.8129C13.3563 22.5296 12.6396 23.2463 12.2096 24.1063ZM13.4996 0.599609C6.33294 0.599609 0.599609 6.33294 0.599609 13.4996C0.599609 20.6663 6.33294 26.3996 13.4996 26.3996C20.6663 26.3996 26.3996 20.6663 26.3996 13.4996C26.3996 6.33294 20.6663 0.599609 13.4996 0.599609Z"></path></svg>
              <div data-testid="mobile-menu_changeMarket" class="font__largeBody font--gray-medium">
                Change Market
              </div>
            </div>
          </a>
        </div>
        <div class="header-menu__language" data-showfooter="Footer" data-showselector="Remove">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" style="height: 12px;">
            <title>USA</title>
            <path fill="#FFF" d="M0 0h513v342H0z"></path>
            <path d="M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z" fill="#D80027"></path>
            <path fill="#2E52B2" d="M0 0h256.5v184.1H0z"></path>
            <path d="m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z" fill="#FFF"></path>
          </svg>
          <p data-testid="activeMarketLanguage" class="font__subheader font--gray-medium text--transform-uppercase">
            USA <strong>|</strong> English
          </p>
          <img data-testid="mobile-menuMarketSelector" class="icon--xsmall" src="https://newulife.com/images/close-red.svg">
        </div>
      </div>
    `
  }

  showMobile_SelectMarket() {
    return `
      <div class="header-menu__select-market">
        <div class="row column--center my--1">
          <img src="//shop-be.newulife.com/cdn/shop/t/10/assets/market-selector_head.webp?v=180518082498191566161781775274" alt="globe" style="height:auto;width:100%;">
        </div>
        <h3 class="font__title2 text--transform-uppercase font--gray-light font--semibold font--center mb--1">
          Select Your Market
        </h3>
        <div class="row column--center">
          <div class="row gap--1">
            ${window.newULifeConfig.markets.map((o) => {
                const isLiveMarket = this.liveShopifyMarkets.some((market) => market === o.name);
                return `
                    <a
                      ${isLiveMarket ? '' : `href="${window.newULifeConfig.bydesignStoreHref}"`}
                      class="font__largeBody font--semibold font--gray selectable font--height-2"
                      style="color: var(--text-dark);"
                      ${isLiveMarket ? `data-showselector="SelectLanguage"` : ''}
                      data-marketmobile="${o.value}"
                      data-isLiveMarket="${isLiveMarket}"
                    >
                      ${o.name}
                    </a>
                  `;
                }).join('')}
          </div>
        </div>
      </div>
    `
  }

  showMobile_SelectLanguage() {
    const shopifyRootUrl = window.newULifeConfig.langSelectorMarket.shopifyUrl || '';
    const marketSelectionLanguages = window.newULifeConfig.langSelectorMarket.languages;
    return `
      <div class="header-menu__select-language header-menu__content">
        <a data-showselector="SelectMarket">
          <div class="header-menu__back header-menu__nav-item--previous">Back</div>
        </a>
        <div class="header-menu__page-name">${window.newULifeConfig.langSelectorMarket.name}</div>
        <div class="row gap--1 column--center">
          <div class="font__largeBody font--semibold font--gray-light text--transform-uppercase"></div>
          <div class="row gap--1">
            ${marketSelectionLanguages.map((o) => `
                <a 
                  class="font__largeBody font--semibold font--gray selectable" 
                  href="${this.buildLanguageTargetUrl(o.shopifyHref, shopifyRootUrl)}"
                  data-language-market="${window.newULifeConfig.langSelectorMarket.name}"
                >
                  ${o.name}
                </a>
              `).join('')}
          </div>
        </div>
      </div>
    `
  }

  addMobileEventListeners() {
    const mobileMenuElement = document.getElementById('mobile-menu_content');
    const mobileFooterElement = document.getElementById('mobile-footer');
    const mobileFooterSelectElement = document.getElementById('header-menu__select');
  
    document.addEventListener('click', e => {
      const marketRedirectTarget = e.target.closest('[data-language-market]');
      if (marketRedirectTarget) {
        var languageMarket = marketRedirectTarget.getAttribute('data-language-market');
        var customerEmail = window.customerEmail;
        if (!!customerEmail && languageMarket) {
          e.preventDefault();
          e.stopPropagation();
          this.marketChangeForCustomer(languageMarket);
        }
      }
      // Handle non-Shopify market selection (mobile)
      const marketTarget = e.target.closest('[data-marketmobile]');
      if (marketTarget) {
        const marketValue = marketTarget.getAttribute('data-marketmobile');
        const isLiveMarket = marketTarget.getAttribute('data-isLiveMarket');
        if (isLiveMarket === 'false' && !!window?.customerInfoMetafields?.customerId && window?.customerInfoMetafields?.customerType === "representative") {
          e.preventDefault();
          e.stopPropagation();
          this.redirectToNonShopifyMarket(
            window.newULifeConfig.bydesignStoreHref,
            marketValue
          );
        }
      }
      
      const target = e.target.closest('[data-show]');
      if (target) {
        const showFunctionName = `showMobile_${target.getAttribute('data-show')}`;
        const showFunction = this[showFunctionName].bind(this);
  
        if (typeof showFunction === 'function') {
          mobileMenuElement.innerHTML = showFunction();
        }
      }

      const footerTarget = e.target.closest('[data-showfooter]');
      if (footerTarget) {
        const showFunctionName = `showMobile_${footerTarget.getAttribute('data-showfooter')}`;
        const showFunction = this[showFunctionName].bind(this);
  
        if (typeof showFunction === 'function') {
          document.querySelector('.header-menu__scrim').classList.toggle('active');
          mobileFooterElement.innerHTML = showFunction();
        } 
      }

      const selectorTarget = e.target.closest('[data-showselector]');
      if (selectorTarget) {
        const selectorName = selectorTarget.getAttribute('data-showselector');
        const marketValue = selectorTarget.getAttribute('data-marketmobile');
        if (selectorName === 'Remove') {
          mobileFooterSelectElement.innerHTML = ``;
        } else {
          const showFunctionName = `showMobile_${selectorName}`;
          const showFunction = this[showFunctionName].bind(this);
    
          if (typeof showFunction === 'function') {
            if (marketValue) {
              window.newULifeConfig.markets.forEach(o => {
                if (o.value === marketValue) window.newULifeConfig.langSelectorMarket = o;
              })
            }
            mobileFooterSelectElement.innerHTML = showFunction();
          } 
        }
      }
    });

    document.querySelector('.header--open').addEventListener('click', e => {
      document.body.style.overflow = 'hidden';
      document.getElementById('mobile-menu').style.display = 'block';
    });
    
    document.querySelector('.header--close').addEventListener('click', e => {
      document.body.style.overflow = '';
      document.getElementById('mobile-menu').style.display = 'none';
    });
  }
}

customElements.define('header-component', HeaderComponent);